export const state = {
  items: [],
  loading: false,
  totalItems: 0,
  isError: false,
  errorMessage: null
};
